import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

const TILES = [
  { src: "/photos/salon-1.jpg", alt: "The Salon Orgænics logo wall" },
  { src: "/photos/salon-2.jpg", alt: "The salon floor" },
  { src: "/videos/salon-2.jpg", alt: "Inside the salon" },
  { src: "/photos/salon-5.jpg", alt: "Shelf details with creeping greens" },
  { src: "/photos/salon-3.jpg", alt: "Mirrors and natural light" },
  { src: "/videos/salon-3.jpg", alt: "The storefront" },
  { src: "/photos/salon-4.jpg", alt: "The ritual chair" },
  { src: "/videos/salon-4.jpg", alt: "The space, in motion" },
];

function Row({ tiles }) {
  return (
    <div className="flex shrink-0 gap-4 pr-4">
      {tiles.map((t, i) => (
        <img
          key={i}
          src={t.src}
          alt={t.alt}
          loading="lazy"
          className="h-52 md:h-72 w-auto object-cover border border-[#E5E7E3]"
        />
      ))}
    </div>
  );
}

export default function PhotoMarquee() {
  const [tiles, setTiles] = useState(TILES);
  useEffect(() => {
    axios
      .get(`${API}/content/gallery`)
      .then((r) => {
        if (r.data?.marquee?.length) setTiles(r.data.marquee);
      })
      .catch(() => {});
  }, []);
  return (
    <div className="bg-[#F9FAF8] py-5 overflow-hidden" data-testid="photo-marquee" aria-label="Salon photo strip">
      <div className="marquee-track flex w-max">
        <Row tiles={tiles} />
        <Row tiles={tiles} />
      </div>
    </div>
  );
}
